<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Questionari di {{patient.name}}
  {{patient.surname}}</h2>

<div class="container && mat-elevation-z5">

  <ng-container
    *ngIf="patient.questionnaires !== null && patient.questionnaires.length > 0; else noClinicalQuestionnaireSet">

    <h3 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Medico</h3>

    <table class="clinical-table" mat-table [dataSource]="dataSourceClinical">

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire}} </td>
      </ng-container>

      <ng-container matColumnDef="pendings">
        <th mat-header-cell *matHeaderCellDef> In sospeso </th>
        <td mat-cell *matCellDef="let questionnaire">
          <ng-container *ngIf="calcPendings(questionnaire) > 0; else noPendings">
            <button mat-raised-button matBadge="{{calcPendings(questionnaire)}}" matBadgePosition="after"
              matBadgeColor="accent" color="primary" (click)="goToClinicalPendings(questionnaire)">Apri</button>
          </ng-container>
          <ng-template #noPendings>
            <button mat-raised-button color="primary" (click)="goToClinicalPendings(questionnaire)">Apri</button>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="completed">
        <th mat-header-cell *matHeaderCellDef> Completati </th>
        <td mat-cell *matCellDef="let questionnaire">
          <ng-container *ngIf="calcCompletedAndNotRead(questionnaire) > 0; else allReadClinical">
            <button mat-raised-button color="primary" matBadge="{{calcCompletedAndNotRead(questionnaire)}}"
              matBadgePosition="after" matBadgeColor="accent" (click)="goToQuestionnaire(questionnaire)">Apri</button>
          </ng-container>
          <ng-template #allReadClinical>
            <button mat-raised-button color="primary" (click)="goToQuestionnaire(questionnaire)">Apri</button>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="sendNew">
        <th mat-header-cell *matHeaderCellDef> Invia nuovo </th>
        <td mat-cell *matCellDef="let questionnaire">
          <button mat-raised-button color="primary" (click)="sendNew(questionnaire)">Invia</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef> Rimuovi </th>
        <td mat-cell *matCellDef="let questionnaire">
          <button mat-raised-button color="warn" (click)="openRemoveQuestionnaireDialog(questionnaire)">Rimuovi</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsForClinical; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsForClinical;"></tr>
    </table>
  </ng-container>

  <ng-template #noClinicalQuestionnaireSet>
    <h3 style="text-align: center;">Nessun questionario clinico aggiunto per il paziente.</h3>
  </ng-template>

</div>

<div class="container && mat-elevation-z5" style="margin-top: 30px">

  <ng-container *ngIf="patient.questionnaires !== null && patient.questionnaires.length > 0; else noQuestionnaireSet">

    <h3 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Paziente</h3>

    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire}} </td>
      </ng-container>

      <ng-container matColumnDef="open">
        <th mat-header-cell *matHeaderCellDef> Compilati tttt </th>
        <td mat-cell *matCellDef="let questionnaire">
          <ng-container *ngIf="calcCompletedAndNotRead(questionnaire) > 0; else allRead">
            <button mat-raised-button color="primary" matBadge="{{calcCompletedAndNotRead(questionnaire)}}"
              matBadgePosition="after" matBadgeColor="accent" (click)="goToQuestionnaire(questionnaire)">Apri</button>
          </ng-container>
          <ng-template #allRead>
            <button mat-raised-button color="primary" (click)="goToQuestionnaire(questionnaire)">Apri</button>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="completed">
        <th mat-header-cell *matHeaderCellDef> N. completati </th>
        <td mat-cell *matCellDef="let questionnaire">
          {{calcCompleted(questionnaire)}}
        </td>
      </ng-container>

      <ng-container matColumnDef="timer">
        <th mat-header-cell *matHeaderCellDef> Timer </th>
        <td mat-cell *matCellDef="let questionnaire">
          <button mat-raised-button color="primary" (click)="addJobDialog(questionnaire)">Imposta timer</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actualFreq">
        <th mat-header-cell *matHeaderCellDef> Intervallo attuale </th>
        <td mat-cell *matCellDef="let questionnaire">
          <div *ngIf="nameAndDaysReady">{{nameAndDaysQuestionnaireMap[questionnaire]}}</div>
          <div *ngIf="!nameAndDaysReady"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="sendNew">
        <th mat-header-cell *matHeaderCellDef> Invia nuovo </th>
        <td mat-cell *matCellDef="let questionnaire">
          <button mat-raised-button color="primary" (click)="sendNew(questionnaire)">Invia</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef> Rimuovi </th>
        <td mat-cell *matCellDef="let questionnaire">
          <button mat-raised-button color="warn" (click)="openRemoveQuestionnaireDialog(questionnaire)">Rimuovi</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>

  <mat-paginator style="padding: 20px; vertical-align: middle; text-align: center" [pageSizeOptions]="[5, 10, 25, 100]"
    showFirstLastButtons></mat-paginator>

  <ng-template #noQuestionnaireSet>
    <h3 style="text-align: center;">Nessun questionario scelto per il paziente.</h3>
  </ng-template>

</div>

<div style="text-align: center; padding-top:60px; padding-bottom: 40px;">
  <h4 style="font-size: 17px; font-weight: bold; ">Aggiungi un nuovo tipo di questionario da far compilare al paziente
  </h4>
  <button mat-raised-button color="primary" (click)="addQuestionnaireDialog()">Aggiungi</button>
</div>